import {CreateInstance} from './config'
const deviceGroupAPI = CreateInstance('device-groups')
export default deviceGroupAPI
